import React from "react";
import PropTypes from "prop-types";

import globalStyles from "globalStyles";

const Footer = (props) => {
  const { author, year } = props;

  return (
    <div style={styles.footer}>
      <span style={styles.author}>{author} </span>
      <span style={styles.year}> est. {year}</span>
    </div>
  );
};

const styles = {
  footer: {
    ...globalStyles.darkBackground,
    ...globalStyles.spaced,
    paddingTop: "0.25rem",
    paddingBottom: "0.1rem",
    textAlign: "center",
  },
  author: {
    fontWeight: "bold",
    ...globalStyles.textLightGreyColor,
    fontSize: "0.9rem",
  },
  year: {
    ...globalStyles.textLightBlueColor,
    fontSize: "0.9rem",
  },
};

Footer.propTypes = {
  author: PropTypes.string,
  year: PropTypes.number,
};

export default Footer;
